module.exports = __webpack_public_path__ + "img/img16.debd9e3d.png";